import React from "react"

import { PrimitiveText } from "@/primitives/PrimitiveText"
import { BodyTextProps } from "@/components/Text/protocols"

import { SxProps, Theme } from "@mui/material"

import useStyles from "@/components/Text/Body/styles"
import { FONT } from "@/styles/fonts"

export const Body = (props: BodyTextProps) => {
	const {
		children,
		color,
		type,
		textTransform = "none",
		fontWeight = "regular",
		gutterBottom = false,
		sx
	} = props

	const classes = useStyles()

	const getBodyStyle = () => {
		const bodyTypeToBodyStyle: Record<BodyTextProps["type"], SxProps<Theme>> = {
			large: classes.large,
			default: classes.default,
			small1: classes.small1,
			small2: classes.small2,
			smaller1: classes.smaller1,
			smaller2: classes.smaller2,
			smaller3: classes.smaller3
		}

		const bodyStyle = bodyTypeToBodyStyle[type]

		return bodyStyle
	}

	return (
		<PrimitiveText
			sx={[{ color: color, fontWeight: FONT.fontWeight[fontWeight] }, getBodyStyle(), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as SxProps<Theme>}
			textTransform={textTransform}
			gutterBottom={gutterBottom}
		>
			{children}
		</PrimitiveText>
	)
}